(ns teamoesterreich.user-mode.warnings.warning-location
  (:require [clojure.string]
            [goog.date.DateTime]
            [goog.json :as json]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.config :as config]
            [teamoesterreich.firebase.fb-warning :as fb-warning]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.warnings.warning-helper :as w-helper]
            ))




(defn warning-card [warning]


  [:div {:style {:display         "block" :verticalAlign "top"
                 :padding         "10px"
                 :marginBottom    "10px"
                 :backgroundColor (w-helper/warning-color (:type warning) (:level warning))}}

   [mui/grid
    {:container  true
     :direction  "row"
     :justify    "center"
     :alignItems "flex-start"
     :spacing    1
     }
    [mui/grid {:container false :item true :xs 9}
     [:div {:style {:backgroundColor "white" :padding "3px"}}
      "Zeitraum: "
      (when-let [from (:validity-from warning)] (str (.toLocaleDateString (js/Date. (* 1000 (.-seconds ^js from)))) " " (subs (.toLocaleTimeString (js/Date. (* 1000 (.-seconds ^js from)))) 0 5)))
      (when-let [to (:validity-to warning)] (str " - " (.toLocaleDateString (js/Date. (* 1000 (.-seconds ^js to)))) " " (subs (.toLocaleTimeString (js/Date. (* 1000 (.-seconds ^js to)))) 0 5)))
      [:br]
      (:warntext warning)
      ]
     (when (not= "" (str "" (:measure warning)))
       [:div {:style {:backgroundColor "white" :padding "3px"}}
        "Maßnahme:" [:br]
        (:measure warning)
        ])]
    [mui/grid {:container false :item true :xs 3}
     [:div {:style {:text-align "right" :padding "7px 20px 0 0" :width "100%" :height "100%"
                    :fontSize   "20px"
                    :color      "white"}}
      "Stufe " (:level warning)]]
    ]]

  )

(defn location-warnings [locationId]
  (let [location-warnings-clustered (fb-warning/get-clustered-sorted-actual-location-warnings locationId)]
    (if (= 0 (count location-warnings-clustered))

      [mui/typography {:variant "h6" :component "h6" :style {:color "#385738"}}
       "Aktuell keine Warnungen für diesen Standort!"]


      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "flex-start"
        :spacing    1
        }
       [mui/grid
        {:container false
         :item      true
         :lg        12
         :xs        12
         }
        (for [[k w-type] location-warnings-clustered]

          ^{:key (str "warningType-" (:type w-type))}

          [mui/paper {:style      {:padding      "0 5% 0 5%"
                                   :width        "100%"
                                   :border-color (w-helper/warning-color (:type w-type) (:maxLevel w-type))
                                   :border-width "5px" :border-style "solid" :margin-top "15px"}
                      :class-name "wrap-content-card"
                      }
           [:div {:style {:display "none" :vertical-align "top"}} (json/serialize (clj->js w-type))]
           [:img {:style {:float "right" :width "80px" :margin "5px 5px"}
                  :src   (w-helper/warning-image (:type w-type) (int (:maxLevel w-type)))
                  :alt   (w-helper/warning-name (:type w-type) (int (:maxLevel w-type)))}]
           [:h3
            {:style {:margin "35px 0 35px 0"}}
            (w-helper/warning-name (:type w-type) (int (:maxLevel w-type)))]

           (for [warning (:warnings w-type)]
             ^{:key (str "warning-" (:warnId w-type))}
             [warning-card warning])
           ]
          )

        ]])))


(defn get-it []
  (fn []
    (let [!selected-location (r/cursor store/app-state [:state :selected-location])
          locationId @!selected-location
          !location (r/cursor store/app-state [:locations locationId])
          location @!location

          lat (and (get-in location [:coordinates]) (.-_lat ^js (get-in location [:coordinates])))
          lng (and (get-in location [:coordinates]) (.-_long ^js (get-in location [:coordinates])))
          ]

      [mui/grid
       {:style      {:margin-top "15px"}
        :container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    4
        }

       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        12

         }

        [mui/card
         [mui/card-content
          {:style {:display "flex" :flexDirection "row"}}

          [mui/card-media
           {:component "img"
            :style     {:flex "0 1 400px"}
            :image     (or (when-not (= "" (:location-picture-path-fst location)) (:location-picture-path-fst location))
                           (and lat lng
                                (str "https://maps.googleapis.com/maps/api/staticmap?"
                                     "center=" lat "," lng "&zoom=14&size=400x300&"
                                     "markers=color:red|" lat "," lng
                                     "&key= " config/GOOGLE_MAPS_API "&"
                                     ))
                           "/custom/img/home.png")
            :title     (str (get-in location [:name]))
            :alt       (str (get-in location [:name]))
            }]


          [mui/card-content
           {:style {:flex "1 0 auto"}}
           [mui/typography {:variant "h5" :component "h5"}
            (str (get-in location [:name]))]
           [mui/typography {:variant "body2" :component "p" :color "textSecondary"}
            (str (get-in location [:address]))]
           ]]
         [mui/card-content
          {:style {:textAlign "left"}}
          [mui/typography {:variant "h6" :component "h6"}
           "Aktuelle Warnungen:"]

          [location-warnings locationId]

          ]

         [mui/card-actions
          [mui/button {:title     "Standort bearbeiten"
                       :variant   "outlined"
                       :onClick   (fn [] (reset! !selected-location locationId)
                                    (a/set-page :warning-locationView))
                       :startIcon (r/as-element [edit])
                       }
           "Standort Details"
           ]
          ]
         ]

        ]

       [mui/grid
        {:container false
         :item      true
         :xs        12

         }
        [mui/button
         {:variant   "contained"
          :class     "bottom-button"
          :onClick   #(a/set-page-back)
          :startIcon (r/as-element [keyboard-arrow-left])
          }
         "Zurück"]]
       ]

      )))